import { render } from "./popper.vue?vue&type=template&id=7911aec4"
import script from "./popper.vue?vue&type=script&lang=js"
export * from "./popper.vue?vue&type=script&lang=js"

import "./popper.vue?vue&type=style&index=0&id=7911aec4&lang=less"
/* custom blocks */
import block0 from "./popper.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__